import "./App.css";
import Payment from "./Payment";
import Completion from "./Completion";
import Pricing from "./Pricing";
import  Login  from "./Login";
import Signup from "./Signup"
import Terms from "./terms";
import SportApp from "./sportsc/SportApp";
import ForgotPassword from "./ForgotPassword";
import Demo from "./sportsc/Demo";
import Home from "./sportsc/Home"
import { Routes, Route , useNavigate, NavLink,Link, useLocation } from "react-router-dom";
import { useContext } from 'react';
import { PriceContext } from './context';
import { AwsConfigAuth } from "./config/auth";
import {Amplify} from "aws-amplify";
import React, { useState, Fragment, useEffect, useLayoutEffect } from "react"; // Import useLayoutEffect
import styled from "styled-components";
import { logout } from './authenticate';
import SpringNav from "./sportsc/Nav";
import Account from './Account';
import { animated, useSpring } from "react-spring";
import Teams from "./teams";
import Articles from "./Articles";
import Admin from "./Admin";
import Config from "./config";
import Checks from "./checks";
import ProtectedRoute from "./containers/ProtectedRoute";


  const Nav = styled.nav`
  position: fixed;
  width: 100vw;
  box-shadow: 0 0 10px $clr-gray300;
  @media (min-width: 768px) {
  
  }

`;

const NavList = styled.ul`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 2rem;
  margin: 0 2rem;
`;

const NavLogo = styled.li`
  list-style: none;
  margin-right: auto;
  cursor: pointer;

  svg {
    width: 2.5rem;
    transition: fill 250ms ease-in;

    &:hover,
    &:focus {
      fill: $clr-primary;
    }
  }
`;

const NavListItemDrop = styled.ul`
  display: ${props => (props.isOpen ? 'flex' : 'none')}; /* Show/hide based on state */
  flex-direction: column; /* Organiza los elementos en una columna */
  justify-content: space-around; /* Espacia uniformemente los elementos */
  position: absolute;
  background-color: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  padding: 1rem;
  list-style: none;
  height: 10vh;
  right: 1; /* Alinea el menú desplegable con el borde derecho */
  transform: translateX(-50%); /* Ajusta el valor según sea necesario para moverlo a la izquierda */

  li {
    padding: 0.5rem 0;
  }

  a{
    color: black;
    &:hover {
      color: #e0f2fe;
    }

  }
`;
const NavListItem = styled.li`
  list-style:none;
  color:white;
  cursor: pointer;
  z-index:701;
`;
  const NavbarContainer = styled.nav`
  grid-area: navbar;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height:10svh;
  background-color: #131516; /* YouTube red */
  padding: 0 3rem;
  // position: fixed;
  // top: 0;
  // left: 0;
  .brand {
    font-size: 1.5rem;
    text-decoration: none;
    color: white;
  }

  .links {
    display: flex;
    gap: 1rem;

 
    }
  }

  .toggle {
    display: none;
  }


`;

const Container = styled.div`
   /* Prevents stretching */
  /* Add any other styles you want for the parent here */
`;
const route_container = styled.div`
  display:flex;
  min-heigt:100svh;
  min-width:100vw;


`;

const Text = styled.p`
color:  ${props => (props.isOpen ? 'white' : 'blue')};
`

const FooterContainer = styled.footer`
  grid-area: footer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 5svh; /* Or adjust as needed */
  background-color:#1e2124; /* Same as Navbar */
  padding: 0 3rem;
  color: white;
  font-size: 0.8rem;
  bottom: 0;
  left: 0;
  width: 100%;


`;
function App() {
  const { teamCount, setTeamCount, price, setPrice ,isAuthenticated,userHasAuthenticated} = useContext(PriceContext);
  const [isAuthenticating, setIsAuthenticating] = useState(true);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [browserWidth, setBrowserWidth] = useState(window.innerWidth);
  
  useEffect(() => {
    // Function to update the width state
    const handleResize = () => {
      
      setBrowserWidth(window.innerWidth);

    };

    // Add event listener when the component mounts
    window.addEventListener('resize', handleResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); // The empty dependency array ensures this effect runs only once on mount and cleans up on unmount

   console.log(browserWidth)
   if (browserWidth < 600){
    let setWidth = 100;
   }

  let shift = useSpring({
    transform: isDropdownOpen ? `translate3d(0,0,0)` : `translate3d(-200%, 0,0)`, 
    marginLeft: browserWidth < 600 ? `0rem` : `11rem`,
    width: browserWidth < 600 ? `100%` : `60%` 
  })

  let shiftTwo = useSpring({
    transform: isDropdownOpen ? `translate3d(0,0,0)` : `translate3d(-200%, 0,0)`, 
    marginLeft: browserWidth < 600 ? `0rem` : `11rem`,
    width: browserWidth < 600 ? `100%` : `60%` 
  })




  const navigate = useNavigate();
  console.log("this is price", price);
  

function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null; // This component doesn't render anything
}
async function handleLogout(event) {
  event.preventDefault();

  try {
    console.log('logged out')
    logout(userHasAuthenticated)
  } catch (error) {
    console.log(error);
  }
}

const handleDropdownClick = () => {
  setIsDropdownOpen(!isDropdownOpen);
};

  return (

   <animated.div className="App">
          <ScrollToTop />

      <NavbarContainer isOpen={handleDropdownClick}> 
      
            <NavLink to="/" className="brand">
              StatTracker
            </NavLink>
            <div className="toggle" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            
            </div>
            <div className={`links ${isMenuOpen ? "active" : ""}`}>
              (
                <>
                    <NavListItem onClick={handleDropdownClick}>
                   <Text isOpen={handleDropdownClick}>
                    Menu
                   </Text>
                    

        </NavListItem>
        <SpringNav style={shift } handleDropdownClick={handleDropdownClick}/>
                </>
              )
            </div>
          </NavbarContainer>
           
         
      <Routes>  
        <Route path="/config" element={<ProtectedRoute><Config/></ProtectedRoute>} />
        <Route path="/checks" element={<ProtectedRoute><Config/></ProtectedRoute>} />

        <Route path="/admin" element={<ProtectedRoute><Admin/></ProtectedRoute>} />

        <Route path="/payment" element={<ProtectedRoute><Payment /></ProtectedRoute>} />
        <Route path="/pricing" element={<Pricing setPrice={setPrice} navigate={navigate}/>}  price = {price}  setTeamCount={setTeamCount}/>
        <Route path="/completion" element={<Completion />} />
        <Route path="/signup" element={<Signup/>} />
      <Route path="/analysis" element={<ProtectedRoute><SportApp style={shiftTwo} /></ProtectedRoute>} />
        <Route path="/login" element={<Login navigate={navigate} />} />
        <Route path="/demo" element={<Demo/>} />
        <Route path="/" element={<Home />} />
        <Route path="/articles" element={<Articles/>} />

        <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
        <Route path="/forgot" element={<ForgotPassword/>} />
        <Route path="/terms" element={<Terms/>} />

        <Route path="/teams" element={<ProtectedRoute> <Teams teamCount={teamCount} navigate={navigate}/> </ProtectedRoute>} />
      </Routes>
      <FooterContainer>
      <p>&copy; {new Date().getFullYear()} StatTracker</p>
      <div>
        <a href="/privacy">Privacy Policy</a>
{         <Link to='/terms' style={{ textDecoration: 'none', color: 'inherit' }}> 
        <a href="/terms">Terms of Service</a>

</Link>
}        
      </div>
    </FooterContainer>
      </animated.div>

  );
}

export default App;